const Initialarray = {
    MonthPicker:null,
    MonthPicker2:null,
}

export default function DetailMyOb(state = Initialarray, action) {
    switch (action.type) {
        case "set_MonthPicker":
            state = {
                ...state,
                MonthPicker: action.MonthPicker
            }
            break;
        case "set_MonthPicker2":
            state = {
                ...state,
                MonthPicker2: action.MonthPicker2
            }
            break;
        case "set_DefaultmonthPicker":
            state = {
                ...state,
                MonthPicker: null,
                MonthPicker2: null
            }
            break;
        default:

            break;
    }
    return state;
}